import React from 'react';
import { BriefcaseIcon, DollarSignIcon, ShieldIcon, ScaleIcon, CalculatorIcon, UmbrellaIcon } from 'lucide-react';
import { FadeUp } from './ui/FadeUp';
export function PartnerSection() {
  const advisors = [{
    icon: BriefcaseIcon,
    text: 'Benefit brokers'
  }, {
    icon: DollarSignIcon,
    text: 'Payroll providers'
  }, {
    icon: ShieldIcon,
    text: 'PEOs'
  }, {
    icon: ScaleIcon,
    text: 'Employment attorneys'
  }, {
    icon: CalculatorIcon,
    text: 'Fractional CFOs'
  }, {
    icon: UmbrellaIcon,
    text: 'Insurance advisors'
  }];
  return <section className="py-28 bg-section-gray" data-id="element-308">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-309">
        <FadeUp className="text-center max-w-2xl mx-auto mb-16" data-id="element-310">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-311">
            Built to work alongside your existing advisors
          </h2>
          <p className="text-lg text-gray-600" data-id="element-312">
            SparkHR integrates seamlessly with the professionals already
            supporting your business.
          </p>
        </FadeUp>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-16" data-id="element-313">
          {advisors.map((advisor, index) => <FadeUp key={index} delay={index * 0.1} data-id="element-314">
              <div className="bg-white p-6 rounded-xl border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)] h-full flex items-center gap-4" data-id="element-315">
                <div className="w-10 h-10 rounded-xl bg-section-lavender flex items-center justify-center text-purple-400 shrink-0" data-id="element-316">
                  <advisor.icon className="w-5 h-5" data-id="element-317" />
                </div>
                <p className="text-gray-800 font-medium" data-id="element-318">{advisor.text}</p>
              </div>
            </FadeUp>)}
        </div>

        <FadeUp delay={0.4} className="text-center max-w-3xl mx-auto" data-id="element-319">
          <p className="text-xl text-gray-700 font-medium" data-id="element-320">
            Our role is to keep your people operations running smoothly while
            your advisors focus on their expertise.
          </p>
        </FadeUp>
      </div>
    </section>;
}